import Vue from 'vue'
import App from './App.vue'
import router from './router'


import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import './theme/index.css'

Vue.config.productionTip = false
Vue.use(ElementUI);


app = new Vue({
    router,
    render: h => h(App)
}).$mount('#app')

window.root = app.$root.$children[0];
